// Exports
export default {
	"inviteOrCopyFooter": "inviteOrCopyFooter_mCZaw",
	"withLinksMenu": "withLinksMenu_ObMfy",
	"withOverlay": "withOverlay_Y9xx+",
	"shareButtons": "shareButtons_cf7dP",
	"copyButton": "copyButton_BI2PS",
	"copySuccessText": "copySuccessText_VxDdU",
	"okIcon": "okIcon_jlQq4"
};
